import * as aor from "react-admin";
import CardActions from "@material-ui/core/CardActions";
import React, { Component } from "react";
import myRestClient from "../../common/restClient";
import DeleteButton from "../../components/DeleteButton";
import EnableButton from "../../components/EnableButton";
import PermissionDenied from "../../components/PermissionDenied";
import PasswordReset from "../../components/PasswordReset";
import { POLICY_PASSWORD, POLICY_USERS } from "../../common/rolesManagement";
import { getLoggedUserId, getPolicies } from "../../common/authClient";
import { Field } from "redux-form";
import AutoCompleteInputOld from "../../components/AutoCompleteInputOld";
import Select from "react-select";
import tccStyles from "../../common/styles";
import { FormDataConsumer } from "react-admin";

const companyOptions = {
    resource: "companies",
    display: "name",
    label: "Aziende collegate",
    isMulti: true
};

const Actions = ({ permissions, basePath, data }) => {
    const record = { data };
    const del = record && record.data && record.data.deleted;
    return (
        <CardActions
            style={{ zIndex: 2, display: "inline-block", float: "right" }}
        >
            <aor.ShowButton basePath={basePath} record={data} />
            {permissions &&
                !del &&
                permissions.includes(POLICY_USERS.DISABLE) && (
                    <DeleteButton
                        undoable={false}
                        resource="users"
                        message={"Utente disabilitato"}
                        basePath={basePath}
                        record={data}
                        text="resources.users.actions.disable"
                        redirect="users"
                    />
                )}
            {permissions.includes(POLICY_USERS.DISABLE) && del && (
                <EnableButton
                    action="enable_user"
                    resource_id={data.id}
                    current_entity="users"
                    redirect="/users"
                />
            )}
            {permissions.includes(POLICY_USERS.DELETE) && del && (
                <DeleteButton
                    undoable={true}
                    basePath={basePath}
                    record={data}
                    text="resources.users.actions.delete"
                    resource="users"
                    message={"Utente eliminato"}
                    redirect={"users"}
                    dialogContentTitle={"Cancella"}
                    dialogContentText={"ra.actions.deleteSelectedResource"}
                />
            )}
            <aor.ListButton basePath={basePath} />
        </CardActions>
    );
};

const MyToolbar = props => (
    <aor.Toolbar {...props}>
        <aor.SaveButton redirect="show" submitOnEnter={true} />
    </aor.Toolbar>
);
const ResetPasswordButton = ({ record, ...props }) => {
    if (record.new_user && getPolicies().includes(POLICY_PASSWORD.RESET)) {
        return (
            <Field
                {...props}
                id={record.id}
                name="password"
                component={PasswordReset}
            />
        );
    } else {
        return null;
    }
};
export default ({ permissions, ...props }) => {
    const MY_LOGIN_ID = getLoggedUserId();
    if (
        (!getPolicies().includes(POLICY_USERS.UPDATE) &&
            !getPolicies().includes(POLICY_USERS.SELF_UPDATE)) ||
        (getPolicies().includes(POLICY_USERS.SELF_UPDATE) &&
            props.id !== MY_LOGIN_ID.toString())
    ) {
        return <PermissionDenied />;
    }
    return (
        <aor.Edit
            {...props}
            undoable={false}
            title={"resources.users.nameSingular"}
            actions={<Actions permissions={getPolicies()} />}
        >
            <aor.SimpleForm toolbar={<MyToolbar />} redirect="show">
                <aor.TextField source="username" />
                <ResetPasswordButton />
                <aor.TextInput source="surname" validate={[aor.required()]} />
                <aor.TextInput source="name" validate={[aor.required()]} />
                <div>
                    <FormDataConsumer>
                        {({ formData }) =>
                            formData ? <MyType formData={formData} /> : null
                        }
                    </FormDataConsumer>
                </div>
            </aor.SimpleForm>
        </aor.Edit>
    );
};

class MyType extends Component {
    state = {
        disableButton: false,
        inst_types: [],
        company_licenses: [],
        lic_sel: [],
        instTypeSelectDisabled: true
    };

    async componentDidMount() {
        try {
            const params = {
                filter: this.props.filter,
                no_user_filter: true,
                pagination: { page: 1, perPage: 10000 },
                sort: { field: "id", order: "asc" }
            };

            // Chiamata API 1
            const result1 = await myRestClient(
                "GET_LIST",
                "installation_types",
                params
            );
            const data1 = result1.data.map(item => ({
                id: item.id,
                name: item.name,
                licenses: item.licenses
            }));
            this.setState({ inst_types: data1 });

            const result2 = await myRestClient("GET_MANY", "companies", {
                ids: this.props.formData.company_ids
            });
            let licenseIds = result2.data.map(item => item.license_ids);
            const flatArray = licenseIds.flat();
            const uniqueIds = Array.from(new Set(flatArray));
            this.setState({
                company_licenses: this.getOptLic(uniqueIds),
                lic_sel: this.getOptLic(this.props.formData.installation_types)
            });
        } catch (error) {
            console.error(error);
        }
    }

    getOptLic = licenses => {
        if (licenses.length > 0) {
            return licenses
                .filter(license =>
                    this.state.inst_types.some(
                        inst_type => inst_type.id === license
                    )
                )
                .map(license => {
                    const inst_type = this.state.inst_types.find(
                        inst_type => inst_type.id === license
                    );
                    return {
                        value: inst_type.id,
                        label: inst_type.name
                    };
                });
        }
        return [];
    };

    setCompanyValue = value => {
        let arr = value.map(el => el.data.license_ids);
        const flatArray = arr.flat();
        const uniqueIds = Array.from(new Set(flatArray));
        let lic_sel = this.state.lic_sel.map(el => el.value);
        lic_sel = lic_sel.filter(item => uniqueIds.includes(item));
        if (uniqueIds.length > 0) {
            this.setState({
                company: value.label,
                instTypeSelectDisabled: false,
                company_licenses: this.getOptLic(uniqueIds),
                lic_sel: this.getOptLic(lic_sel)
            });
        } else {
            this.setState({
                company: null,
                instTypeSelectDisabled: true,
                company_licenses: this.getOptLic([]),
                lic_sel: this.getOptLic([])
            });
        }
    };

    getStyle = () => {
        return {
            menuPortal: provided => ({
                ...provided,
                zIndex: 9999
            }),
            option: (provided, state) => ({
                ...provided,
                color: tccStyles.colors.black,
                padding: 20,
                backgroundColor: state.isSelected
                    ? tccStyles.colors.lightgrey
                    : tccStyles.colors.white,
                ":active": {
                    backgroundColor:
                        state.isSelected || state.isFocused
                            ? tccStyles.colors.lightgrey
                            : tccStyles.colors.white
                },
                ":hover": {
                    backgroundColor: tccStyles.colors.lightgrey
                }
            }),
            control: (provided, state) => ({
                ...provided,
                borderRadius: 0,
                borderTop: state.isFocused ? 0 : 0,
                borderRight: state.isFocused ? 0 : 0,
                borderLeft: state.isFocused ? 0 : 0,
                borderBottom:
                    this.state.selectValue &&
                    this.state.selectValue.length === 0
                        ? tccStyles.fields.borders.bottomBorderError
                        : tccStyles.fields.borders.bottomBorder,
                // This line disable the blue border
                boxShadow: state.isFocused ? 0 : 0,
                "&:hover":
                    this.state.selectValue &&
                    this.state.selectValue.length === 0
                        ? tccStyles.fields.borders.bottomBorderError
                        : tccStyles.fields.borders.bottomBorderHover
            }),
            indicatorSeparator: () => ({
                display: "none"
            }),
            dropdownIndicator: (provided, state) => ({
                color: tccStyles.colors.main
            }),
            placeholder: (provided, state) => ({
                ...provided,
                // workaround for matching actual style
                marginLeft: -6.5,
                marginTop: 5
            }),
            menu: (provided, state) => ({
                ...provided,
                position: "relative",
                zIndex: 1100
            }),
            singleValue: (provided, state) => ({
                ...provided,
                marginTop: 5,
                marginLeft: this.state.selected === false ? -6.5 : 0
            }),
            multiValue: (provided, state) => ({
                ...provided,
                borderRadius: 25,
                height: 32,
                textAlign: "center"
            }),
            multiValueLabel: (provided, state) => ({
                ...provided,
                marginTop: 5,
                color: tccStyles.colors.black
            })
        };
    };

    render() {
        return (
            <div>
                <div>
                    {getPolicies() &&
                        !getPolicies().includes(POLICY_USERS.SELF_UPDATE) && (
                            <Field
                                onChange={value => {
                                    const company_ids = Object.values(value);
                                    company_ids.splice(-1, 1); // Rimuove l'ultimo elemento
                                    myRestClient("GET_MANY", "companies", {
                                        ids: company_ids
                                    }).then(res_companies => {
                                        let licenseIds = res_companies.data.map(
                                            item => item.license_ids
                                        );
                                        const flatArray = licenseIds.flat();
                                        const uniqueIds = Array.from(
                                            new Set(flatArray)
                                        );
                                        let lic_sel = this.state.lic_sel.map(
                                            el => el.value
                                        );
                                        lic_sel = lic_sel.filter(item =>
                                            uniqueIds.includes(item)
                                        );
                                        this.props.formData.installation_types = lic_sel;
                                    });
                                }}
                                validate={aor.required()}
                                name="company_ids"
                                component={AutoCompleteInputOld}
                                {...{
                                    options: companyOptions,
                                    callBack: this.setCompanyValue
                                }}
                            />
                        )}
                </div>
                <div>
                    {getPolicies() &&
                        !getPolicies().includes(POLICY_USERS.SELF_UPDATE) && (
                            <Field
                                name="installation_types"
                                component={() => (
                                    <Select
                                        label="resources.installations.fields.installation_type_id"
                                        options={this.state.company_licenses}
                                        readonly={
                                            this.state.instTypeSelectDisabled
                                        }
                                        value={this.state.lic_sel}
                                        styles={this.getStyle()}
                                        isMulti
                                        placeholder={"Tipo *"}
                                        onChange={value => {
                                            this.props.formData.installation_types = value.map(
                                                id => id.value
                                            );
                                            this.setState({ lic_sel: value });
                                        }}
                                    />
                                )}
                            />
                        )}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/resources/Users/Edit.js